import { Endpoints, Project } from '@brg/api'
import { GetDesignerName } from 'shared/helpers/utils/DesignerUtils';
import { getImageToWidth } from 'shared/hooks/useResizedImageEnhanced';

export function mapProjectToMapObject(item: Project) {
    return {
      project: item,
      titleImage: `${Endpoints.files}/${getImageToWidth(item?.titleImages, 240)?.url}`,
      title: item.title,
      designer:
        item.coAuthors.length > 0
          ? "Multiply Authors"
          : GetDesignerName(item.author).join(" "),
      designerId: item.authorId,
      likes: item.quCount,
      //@ts-ignore
      competitionId: item.competitionApproves?.[0]?.competitionId,
      projectId: item.projectId,
    };
  }
import { Endpoints, Project } from '@brg/api'
import { GetDesignerName } from 'shared/helpers/utils/DesignerUtils';
import { getImageToWidth } from 'shared/hooks/useResizedImageEnhanced';

export function mapProjectToMapObject(item: Project) {
    return {
      project: item,
      titleImage: `${Endpoints.files}/${getImageToWidth(item?.titleImages, 240)?.url}`,
      title: item.title,
      designer:
        item.coAuthors.length > 0
          ? "Multiply Authors"
          : GetDesignerName(item.author).join(" "),
      designerId: item.authorId,
      likes: item.quCount,
      //@ts-ignore
      competitionId: item.competitionApproves?.[0]?.competitionId,
      projectId: item.projectId,
    };
  }
